import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Shield, Zap, Award, Clock, Lock, CreditCard } from 'lucide-react';
import { useCountUp } from '../hooks/useCountUp';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../hooks/useMetaPixel';
export default function PricingSection() {
  const {
    count: buyersCount,
    ref: buyersRef
  } = useCountUp(1847, 3000, true);
  const [liveBuyers, setLiveBuyers] = useState(3);
  const [scarcityCount, setScarcityCount] = useState(23);
  useEffect(() => {
    const interval = setInterval(() => {
      setLiveBuyers(prev => Math.max(2, Math.min(8, prev + (Math.random() > 0.5 ? 1 : -1))));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() > 0.7 && scarcityCount > 5) {
        setScarcityCount(prev => prev - 1);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [scarcityCount]);
  return <Section id="comprar" className="bg-brand-cream py-20 relative overflow-hidden" data-id="element-291">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-brand-indigo/5 blur-[100px] rounded-full pointer-events-none" data-id="element-292" />

      <div className="max-w-lg mx-auto text-center relative z-10" data-id="element-293">
        <div className="mb-8" data-id="element-294">
          <span className="text-brand-indigo text-xs font-bold tracking-[0.2em] uppercase block mb-2" data-id="element-295">
            Acceso Instantáneo
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-296">
            Protocolo APAGA LA MENTE
          </h2>
        </div>

        {/* Offer Box */}
        <div className="bg-gradient-to-b from-brand-navy to-brand-charcoal rounded-2xl border border-brand-indigo/30 p-8 shadow-2xl relative overflow-hidden mb-8 group hover:border-brand-indigo/50 transition-colors duration-500" data-id="element-297">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-brand-indigo/20 blur-3xl rounded-full pointer-events-none" data-id="element-298" />

          <div className="relative z-10" data-id="element-299">
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} className="text-slate-500 text-lg mb-1 font-medium relative inline-block" data-id="element-300">
              <span className="strikethrough-animate active" data-id="element-301">USD $29.00</span>
            </motion.div>

            <div className="text-5xl sm:text-6xl font-bold text-white mb-4 tracking-tight" data-id="element-302">
              USD $6.39
            </div>

            <div className="inline-block bg-brand-green text-white font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-6 shadow-lg shadow-green-900/20 relative overflow-hidden" data-id="element-303">
              <div className="absolute inset-0 animate-shimmer" data-id="element-304" />
              <span className="relative z-10" data-id="element-305">AHORRAS 66% — SOLO HOY</span>
            </div>

            <div className="flex items-center justify-center gap-2 mb-6 bg-white/5 py-1 px-3 rounded-full w-fit mx-auto border border-white/5" data-id="element-306">
              <span className="relative flex h-2 w-2" data-id="element-307">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-308"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-309"></span>
              </span>
              <span className="text-xs text-slate-400" data-id="element-310">
                Comprando ahora:{' '}
                <span className="font-bold text-white" data-id="element-311">{liveBuyers}</span>{' '}
                personas
              </span>
            </div>

            <div className="border-t border-white/10 pt-6 flex flex-wrap justify-center gap-4 sm:gap-6" data-id="element-312">
              <div className="flex items-center gap-2 text-slate-400 text-sm" data-id="element-313">
                <Shield size={16} className="text-brand-indigo" data-id="element-314" />
                <span data-id="element-315">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2 text-slate-400 text-sm" data-id="element-316">
                <Zap size={16} className="text-brand-amber" data-id="element-317" />
                <span data-id="element-318">Entrega Inmediata</span>
              </div>
              <div className="flex items-center gap-2 text-slate-400 text-sm" data-id="element-319">
                <Clock size={16} className="text-brand-indigo" data-id="element-320" />
                <span data-id="element-321">Acceso de por vida</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4" data-id="element-322">
          <Button variant="primary" size="xl" pulse={true} fullWidth={true} className="text-xl sm:text-2xl py-7 shadow-[0_0_40px_rgba(67,56,202,0.3)] hover:shadow-[0_0_60px_rgba(67,56,202,0.5)] transition-shadow duration-300" onClick={() => {
          trackAddToCart();
          window.open('https://simplementemejor.com/cart/51663061123352:1', '_blank');
        }} data-id="element-323">
            QUIERO APAGAR MI MENTE ESTA NOCHE
          </Button>
        </div>

        <div className="flex flex-col items-center gap-1 mb-10" data-id="element-324">
          <p className="text-red-400 text-sm font-bold animate-pulse" data-id="element-325">
            Solo quedan {scarcityCount} copias a precio de lanzamiento
          </p>
          <p className="text-slate-500 text-xs" data-id="element-326">
            ✓ Descarga inmediata · ✓ Garantía 7 días · ✓ 0 riesgo
          </p>
        </div>

        {/* Guarantee - Compact */}
        <div className="flex items-center justify-center gap-2 mb-4 bg-brand-navy rounded-full px-4 py-2 border border-brand-indigo/20" data-id="element-327">
          <Award className="text-brand-amber w-4 h-4 flex-shrink-0" data-id="element-328" />
          <p className="text-slate-400 text-xs" data-id="element-329">
            <span className="font-bold text-slate-200" data-id="element-330">Garantía 7 días</span> —
            Si no te funciona, te devolvemos el 100%.
          </p>
        </div>

        {/* Secure Payment Banner */}
        <div className="bg-brand-navy rounded-xl border border-white/5 p-4 mb-6 shadow-sm" data-id="element-331">
          <div className="flex items-center justify-center gap-1.5 mb-3" data-id="element-332">
            <Lock size={14} className="text-brand-indigo" data-id="element-333" />
            <span className="text-xs font-bold text-slate-300 uppercase tracking-wider" data-id="element-334">
              Pago 100% Seguro
            </span>
          </div>
          <div className="flex items-center justify-center gap-3 flex-wrap opacity-80" data-id="element-335">
            {/* Visa */}
            <div className="bg-slate-100 rounded-md px-3 py-1.5 border border-slate-200" data-id="element-336">
              <svg viewBox="0 0 48 16" className="h-5 w-auto" fill="none" data-id="element-337">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="14" fill="#1A1F71" data-id="element-338">
                  VISA
                </text>
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-slate-100 rounded-md px-3 py-1.5 border border-slate-200 flex items-center gap-1" data-id="element-339">
              <svg viewBox="0 0 32 20" className="h-5 w-auto" data-id="element-340">
                <circle cx="10" cy="10" r="8" fill="#EB001B" data-id="element-341" />
                <circle cx="22" cy="10" r="8" fill="#F79E1B" data-id="element-342" />
                <path d="M16 3.5a8 8 0 0 1 0 13 8 8 0 0 1 0-13z" fill="#FF5F00" data-id="element-343" />
              </svg>
            </div>
            {/* PayPal */}
            <div className="bg-slate-100 rounded-md px-3 py-1.5 border border-slate-200" data-id="element-344">
              <svg viewBox="0 0 60 16" className="h-5 w-auto" fill="none" data-id="element-345">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" fill="#003087" data-id="element-346">
                  Pay
                </text>
                <text x="22" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" fill="#009CDE" data-id="element-347">
                  Pal
                </text>
              </svg>
            </div>
            {/* Amex */}
            <div className="bg-slate-100 rounded-md px-3 py-1.5 border border-slate-200" data-id="element-348">
              <svg viewBox="0 0 40 16" className="h-5 w-auto" fill="none" data-id="element-349">
                <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="9" fill="#006FCF" data-id="element-350">
                  AMEX
                </text>
              </svg>
            </div>
            {/* Generic card */}
            <div className="bg-slate-100 rounded-md px-3 py-1.5 border border-slate-200 flex items-center gap-1" data-id="element-351">
              <CreditCard size={14} className="text-slate-400" data-id="element-352" />
              <span className="text-[10px] text-slate-500 font-medium" data-id="element-353">
                Débito
              </span>
            </div>
          </div>
          <p className="text-[10px] text-slate-500 text-center mt-2" data-id="element-354">
            Tus datos están protegidos con encriptación SSL de 256 bits
          </p>
        </div>

        <div className="text-center" ref={buyersRef} data-id="element-355">
          <p className="text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-356">
            <Zap size={14} className="text-brand-amber" data-id="element-357" />
            <span className="font-bold text-slate-400" data-id="element-358">{buyersCount}</span>{' '}
            personas ya transformaron sus noches
          </p>
        </div>
      </div>
    </Section>;
}